import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reporting/')({
  component: ReportingIndexPage,
});

function ReportingIndexPage() {
  return <Navigate to="/reporting/report-explorer" replace />;
}
